/**
 * Security configuration generated from OpenAPI spec
 *
 * This file is auto-generated by scripts/generate-security-config.js
 * DO NOT EDIT MANUALLY - changes will be overwritten
 *
 * Generated from commit: b8c249013142bc1c1ceee2b3d29616b6378234c6
 *
 */

/**
 * Public endpoint configuration
 */
interface PublicEndpoint {
  method: string;
  path: string;
  pathPattern: RegExp;
  operationId: string;
  summary: string;
}

/**
 * List of public endpoints that do not require authentication
 */
const PUBLIC_ENDPOINTS: PublicEndpoint[] = [
  {
    method: 'POST',
    path: '/api/v1/quickbooks/webhook',
    pathPattern: /^\/api\/v1\/quickbooks\/webhook$/,
    operationId: 'post /quickbooks/webhook',
    summary: 'Quickbooks webhook',
  },
  {
    method: 'POST',
    path: '/api/v1/sendgrid/webhook',
    pathPattern: /^\/api\/v1\/sendgrid\/webhook$/,
    operationId: 'post /sendgrid/webhook',
    summary: 'SendGrid event webhook',
  },
  {
    method: 'GET',
    path: '/api/v1/public/settings',
    pathPattern: /^\/api\/v1\/public\/settings$/,
    operationId: 'get /public/settings',
    summary: 'Get public settings',
  },
  {
    method: 'POST',
    path: '/api/v1/public/web-forms/submissions',
    pathPattern: /^\/api\/v1\/public\/web-forms\/submissions$/,
    operationId: 'post /public/web-forms/submissions',
    summary: 'Submit a public website form',
  },
  {
    method: 'POST',
    path: '/api/v1/auth/login',
    pathPattern: /^\/api\/v1\/auth\/login$/,
    operationId: 'post /auth/login',
    summary: 'User login',
  },
  {
    method: 'POST',
    path: '/api/v1/auth/refresh',
    pathPattern: /^\/api\/v1\/auth\/refresh$/,
    operationId: 'post /auth/refresh',
    summary: 'Refresh access token',
  },
  {
    method: 'POST',
    path: '/api/v1/auth/google',
    pathPattern: /^\/api\/v1\/auth\/google$/,
    operationId: 'post /auth/google',
    summary: 'Google OAuth login',
  },
  {
    method: 'GET',
    path: '/api/v1/integrations/quickbooks/callback',
    pathPattern: /^\/api\/v1\/integrations\/quickbooks\/callback$/,
    operationId: 'get /integrations/quickbooks/callback',
    summary: 'QuickBooks OAuth callback',
  },
  {
    method: 'GET',
    path: '/api/v1/integrations/hubspot/callback',
    pathPattern: /^\/api\/v1\/integrations\/hubspot\/callback$/,
    operationId: 'get /integrations/hubspot/callback',
    summary: 'HubSpot OAuth callback',
  },
  {
    method: 'POST',
    path: '/api/v1/hubspot/webhook',
    pathPattern: /^\/api\/v1\/hubspot\/webhook$/,
    operationId: 'post /hubspot/webhook',
    summary: 'HubSpot webhook',
  },
  {
    method: 'GET',
    path: '/api/v1/health',
    pathPattern: /^\/api\/v1\/health$/,
    operationId: 'get /health',
    summary: 'Health check',
  },
  {
    method: 'GET',
    path: '/api/v1/version',
    pathPattern: /^\/api\/v1\/version$/,
    operationId: 'get /version',
    summary: 'Get API version',
  },
  {
    method: 'GET',
    path: '/api/v1/emails/scan-next',
    pathPattern: /^\/api\/v1\/emails\/scan-next$/,
    operationId: 'get /emails/scan-next',
    summary: 'Get the next Gmail scan instructions for the calling recruiter',
  },
  {
    method: 'POST',
    path: '/api/v1/emails',
    pathPattern: /^\/api\/v1\/emails$/,
    operationId: 'post /emails',
    summary: 'Forward a batch of applicant emails and close the scan cycle',
  }
];

/**
 * Check if an endpoint is public (does not require authentication)
 *
 * @param url - The request URL (e.g., '/api/v1/auth/login')
 * @param method - The HTTP method (e.g., 'POST', 'GET')
 * @returns true if the endpoint is public, false if it requires authentication
 */
export function isPublicEndpoint(url: string, method: string): boolean {
  // Normalize method to uppercase
  const normalizedMethod = method.toUpperCase();

  // Extract path from full URL if needed
  // Handle both full URLs and path-only URLs
  let path = url;
  try {
    if (url.startsWith('http://') || url.startsWith('https://')) {
      const urlObj = new URL(url);
      path = urlObj.pathname;
    }
  } catch (e) {
    // Not a valid URL, assume it's already a path
  }

  // Strip query string if present
  const queryIndex = path.indexOf('?');
  if (queryIndex !== -1) {
    path = path.substring(0, queryIndex);
  }

  // Check against public endpoint patterns
  for (const endpoint of PUBLIC_ENDPOINTS) {
    if (endpoint.method === normalizedMethod && endpoint.pathPattern.test(path)) {
      return true;
    }
  }

  return false;
}

/**
 * Get list of all public endpoints (for debugging/testing)
 */
export function getPublicEndpoints(): PublicEndpoint[] {
  return [...PUBLIC_ENDPOINTS];
}
